
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http,Response } from '@angular/http';
import { Observable } from 'rxjs';
import { API } from '.././core/app-config';

import { SmsLogReceived } from '../work-order/work-order-models';
import { Country, FPResponse, GlobalInfo, PagerList } from '../shared/shared.model';
@Injectable()
export class ReceivedSmsService {
    constructor(private http: Http) { }


    getSmsReceivedLog(CompanyId: number, MaxRoleGroupId: number,VendorId:number,TechId:number,TimeZoneId:number): Observable<SmsLogReceived[]> {
        return this.http.get(API.WORKORDER + "/GetReceivedSMSLog/?CompanyId=" + CompanyId + '&MaxRoleGroupId=' + MaxRoleGroupId+'&VendorId='+VendorId+'&TechId='+TechId+"&TimeZoneId="+TimeZoneId).pipe(map(res => res.json()));
    }

    insert(smslog: SmsLogReceived): Observable<FPResponse> {

        return this.http.put(API.WORKORDER + '/UpdateReceived', smslog).pipe(
            map(res=>res.json()));
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        console.error('an error occured', error);
        return Promise.reject(error.message || error);
    }
}